module.exports = __webpack_public_path__ + "static/media/Group 29110.66ea2cb3.png";